import { create } from 'zustand'

import { OrderPreviewResponse } from '@/services/cart/OrderPreviewService'
import { CartProductInterface } from '@/types'

interface OrderStateInterface {
  products: CartProductInterface[]
  orderCode: number
  orderId: string
  previewData: OrderPreviewResponse | null
  setProducts: (products: CartProductInterface[]) => void
  setOrderCode: (orderCode: number) => void
  setOrderId: (orderId: string) => void
  setPreviewData: (preview: OrderPreviewResponse | null) => void
  setInitialOrderStore: () => void
}

const initialState = {
  products: [],
  orderCode: 0,
  orderId: '',
  previewData: null,
}

export const useOrderStore = create<OrderStateInterface>((set) => ({
  ...initialState,
  setProducts: (products: CartProductInterface[]) =>
    set(() => ({ products: products })),
  setOrderCode: (orderCode: number) => set(() => ({ orderCode })),
  setOrderId: (orderId: string) => set(() => ({ orderId })),
  setPreviewData: (preview: OrderPreviewResponse | null) =>
    set(() => ({ previewData: preview })),
  setInitialOrderStore: () => {
    set({ products: [], previewData: null })
  },
}))
